var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.mailSettings
        ? _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("mail-settings")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", xl: "6" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("mailFrom") },
                            model: {
                              value: _vm.mailSettings.EmailFrom,
                              callback: function ($$v) {
                                _vm.$set(_vm.mailSettings, "EmailFrom", $$v)
                              },
                              expression: "mailSettings.EmailFrom",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", xl: "6" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("mailName") },
                            model: {
                              value: _vm.mailSettings.EmailName,
                              callback: function ($$v) {
                                _vm.$set(_vm.mailSettings, "EmailName", $$v)
                              },
                              expression: "mailSettings.EmailName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", xl: "6" } },
                        [
                          _c("w-input", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("defaultCcEmail"),
                            },
                            model: {
                              value: _vm.mailSettings.DefaultCCEmail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.mailSettings,
                                  "DefaultCCEmail",
                                  $$v
                                )
                              },
                              expression: "mailSettings.DefaultCCEmail",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", xl: "6" } },
                        [
                          _c("w-input", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("defaultBccEmail"),
                            },
                            model: {
                              value: _vm.mailSettings.DefaultBCCEmail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.mailSettings,
                                  "DefaultBCCEmail",
                                  $$v
                                )
                              },
                              expression: "mailSettings.DefaultBCCEmail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.mailSettings
        ? _c(
            "w-card",
            { staticClass: "mt" },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("signature")))]),
              _c(
                "w-card-content",
                [
                  _c("vue-editor", {
                    attrs: {
                      placeholder: _vm.$ct("signature"),
                      "use-custom-image-handler": "",
                    },
                    on: { "image-added": _vm.handlerImageAdded },
                    model: {
                      value: _vm.mailSettings.Signature,
                      callback: function ($$v) {
                        _vm.$set(_vm.mailSettings, "Signature", $$v)
                      },
                      expression: "mailSettings.Signature",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.mailSettings
        ? _c("app-mail-settings-server", {
            attrs: { "mail-settings": _vm.mailSettings },
            on: {
              saved: function ($event) {
                return _vm.onSettingsSaved($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }